import { render, staticRenderFns } from "./DoubleSwiper.vue?vue&type=template&id=09f77e42&scoped=true"
import script from "./DoubleSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleSwiper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DoubleSwiper.vue?vue&type=style&index=0&id=09f77e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f77e42",
  null
  
)

export default component.exports